<sc-flex vertical fitHeight stretchContent>

  <sc-flex-fitting-content vertical>

    <sc-flex vertical stretchContent [gap]="16">

      @for (condition of conditions; track $index) {
      <yard-condition-editor [context]="context" [condition]="condition"
        (deleteRequested)="onDeleteRequested(condition)"></yard-condition-editor>
      }

    </sc-flex>

  </sc-flex-fitting-content>

  <sc-content-spacer vertical></sc-content-spacer>

  <sc-flex centered>
    <sc-add-action-button large (click)="addCondition()"></sc-add-action-button>
  </sc-flex>
</sc-flex>
